<template>
	<div>
		<b-button
		class="m-l-10 m-b-10"
		v-if="items.length && can('vender.limpiar_venta')"
		variant="outline-danger"
		@click="call_limpiar_vender">
			<i class="icon-undo"></i>
			Limpiar
		</b-button>
	</div>
</template>

<script>
import vender from '@/mixins/vender'
export default {
	mixins: [vender],
	methods: {
		call_limpiar_vender() {
			if (confirm('¿Seguro que quiere reiniciar esta venta?')) {
				this.limpiar_vender()
			}
		}
	},
	computed: {
		items() {
			return this.$store.state.vender.items
		}
	}
}
</script>
